<section class="main-banner">
  <div class="main-banner__content">
    <h2 class="title-lg main-banner__title">
      {{ 'mainPageComponent.mainBannerComponent.header' | translate }}
    </h2>
    <p class="subtitle-md main-banner__text">
      {{ 'mainPageComponent.mainBannerComponent.bannerText' | translate }}
    </p>
    @if (!isLoggedIn()) {
      <div class="main-banner__actions">
        <button class="btn-primary main-banner__button" [routerLink]="appRoutes.SIGN_UP">
          {{ 'mainPageComponent.mainBannerComponent.bannerButton' | translate }}
        </button>
        <div class="main-banner__sign-in">
          <span>{{ 'mainPageComponent.mainBannerComponent.or' | translate }}</span>
          <a [routerLink]="appRoutes.LOGIN" class="main-banner__sign-in-link">
            {{ 'mainPageComponent.mainBannerComponent.signIn' | translate }}
          </a>
        </div>
      </div>
    }
  </div>
  <div class="main-banner__image">
    <img src="assets/images/banner.png" alt="" />
  </div>
</section>
